/* DermaShine — timer offerta nativo. Creato il 25/09/2026.
   Sostituisce il countdown dell'app Hextom "Sales Boost".

   COSA FA
   - Trova il box [data-ds-timer] stampato (nascosto) da snippets/ds-timer.liquid
     in fondo al <body> e lo sposta nel punto giusto:
       pagina prodotto → dentro #ds-bund, prima del primo bottone d'acquisto
                         (.ds-buynow «Acquista ora», altrimenti .ds-addcart)
       carrello        → dentro #dsc-cart, prima del form .dsc-form che contiene
                         «Procedi al pagamento» (solo se data-ds-cart="true";
                         il carrello vuoto non ha quel form → niente timer)
     Se non trova nessun ancoraggio il box resta nascosto e non succede nulla.
   - Legge la scadenza da data-ds-end-ts (epoch in secondi, calcolato dal
     Liquid nel fuso dello store) o, in riserva, da data-ds-end (ISO con offset).
     E' un istante assoluto: il conto e' identico per chiunque, ovunque sia.
   - Aggiorna ogni secondo gg / ore / min / sec a due cifre.
   - Allo scadere toglie il box dalla pagina e ferma tutto: non riparte mai.
   - Niente cookie, niente localStorage, nessuna dipendenza. Vanilla JS. */
(function () {
  'use strict';

  var SEL_PRODOTTO = ['#ds-bund .ds-buynow', '#ds-bund .ds-addcart'];
  var SEL_CARRELLO = ['#dsc-cart form.dsc-form'];

  function due(n) { return (n < 10 ? '0' : '') + n; }

  function primo(selettori) {
    for (var i = 0; i < selettori.length; i++) {
      var el = null;
      try { el = document.querySelector(selettori[i]); } catch (e) { el = null; }
      if (el) return el;
    }
    return null;
  }

  function scadenza(box) {
    var ts = parseInt(box.getAttribute('data-ds-end-ts'), 10);
    if (isFinite(ts) && ts > 0) return ts * 1000;
    var iso = Date.parse(box.getAttribute('data-ds-end') || '');
    return isFinite(iso) ? iso : NaN;
  }

  function avvia() {
    var box = document.querySelector('[data-ds-timer]');
    if (!box || box.getAttribute('data-ds-init') === '1') return;
    box.setAttribute('data-ds-init', '1');

    var fine = scadenza(box);
    if (!isFinite(fine)) { box.parentNode && box.parentNode.removeChild(box); return; }

    /* gia' scaduto: via subito, senza mostrarlo */
    if (fine - Date.now() <= 0) { box.parentNode && box.parentNode.removeChild(box); return; }

    /* dove metterlo */
    var ancora = primo(SEL_PRODOTTO);
    var dove = 'prodotto';
    if (!ancora && box.getAttribute('data-ds-cart') === 'true') {
      ancora = primo(SEL_CARRELLO);
      dove = 'carrello';
    }
    if (!ancora || !ancora.parentNode) return;   /* nessun ancoraggio: resta nascosto */

    ancora.parentNode.insertBefore(box, ancora);
    box.classList.add('ds-timer--' + dove);

    var vD = box.querySelector('[data-ds-d]');
    var vH = box.querySelector('[data-ds-h]');
    var vM = box.querySelector('[data-ds-m]');
    var vS = box.querySelector('[data-ds-s]');
    var timer = null;

    function chiudi() {
      if (timer) { clearInterval(timer); timer = null; }
      if (box.parentNode) box.parentNode.removeChild(box);
    }

    function tick() {
      var resta = Math.floor((fine - Date.now()) / 1000);
      if (resta <= 0) { chiudi(); return; }
      var g = Math.floor(resta / 86400);
      var h = Math.floor((resta % 86400) / 3600);
      var m = Math.floor((resta % 3600) / 60);
      var s = resta % 60;
      if (vD) vD.textContent = due(g);
      if (vH) vH.textContent = due(h);
      if (vM) vM.textContent = due(m);
      if (vS) vS.textContent = due(s);
    }

    tick();
    box.hidden = false;
    timer = setInterval(tick, 1000);

    /* tornando da una scheda in background il primo tick puo' essere in
       ritardo di qualche secondo: riallineo subito */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && timer) tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
